import React, {useCallback, useEffect} from "react";
import "./App.css";
import CPSRoutes from "./routes";
import {useLocation} from "react-router-dom";
import trackPathForAnalytics from "./firebaseAnalytics/firebaseAnalytics";

function App() {
  //setFirebaseAnalytics();
  return <CPSRoutes />;
}

function setFirebaseAnalytics() {
  const {pathname, search} = useLocation();

  const analytics = useCallback(() => {
    trackPathForAnalytics({
      path: pathname,
      search,
      title: pathname.split("/")[1],
    });
  }, [pathname, search]);

  useEffect(() => {
    analytics();
  }, [analytics]);
}

export default App;
